var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogosGeoTraxHorizontal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 127,
    height: 25,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M10.63 0c5.117 0 9.28 4.087 9.28 9.108 0 4.919-8.666 14.547-9.034 14.955l-.246.272-.246-.274a62 62 0 0 1-1.345-1.56l-.276-.33-.292-.355-.16-.193 4.226-5.695c2.065-2.893 3.56-4.985 3.56-6.82 0-2.947-2.453-5.344-5.467-5.344S5.165 6.161 5.165 9.108c0 .993.466 2.07 1.226 3.333l1.405-2.156a2.9 2.9 0 0 1-.208-1.088c0-1.65 1.362-2.986 3.042-2.986 1.681 0 3.043 1.336 3.043 2.986 0 1.649-1.362 2.986-3.043 2.986l.164-.005-2.474 3.545c-.157.32-.622.968-1.749 2.525l-.16.221-.266.368-.268-.368c-3.003-4.133-4.526-7.284-4.526-9.361C1.351 4.087 5.514 0 10.631 0z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M0 0h13.044v10.36H0z"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: "50%",
    x2: "50%",
    y1: "0%",
    y2: "100%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#00C1F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#008EF3"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "a",
    width: "121.6%",
    height: "116.4%",
    x: "-10.8%",
    y: "-4.1%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 .46)"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "#000",
    filter: "url(#a)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#b",
    fill: "url(#c)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M77.327 6.498v3.19H72.45V20.05h-3.997V9.687h-4.857v-3.19zm3.412 7.891h.998c.96 0 1.49-.484 1.49-1.199s-.55-1.16-1.45-1.16h-1.038zm1.605-4.696c2.802 0 4.427.965 4.427 3.225 0 1.084-.548 2.147-1.371 2.668.547.387.94 1.392 1.215 2.088l.959 2.377H83.91l-.724-2.164c-.353-1.044-.666-1.45-1.392-1.45H80.74v3.614h-3.41V9.693z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m92.981 13.132-1.076 3.402h2.467l-1.39-3.402zm2.038-3.44 4.564 10.359h-3.918l-.529-1.43h-3.838l-.392 1.43h-3.603l3.915-10.359z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(97.901 9.692)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "e",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#d"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "m4.525 0 1.998 2.975L8.52 0h4.17L8.599 4.967l4.447 5.393H8.872l-2.35-3.384-2.351 3.384H0l4.426-5.393L.332 0z",
    mask: "url(#e)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M42.432 10.57c-1.46-.846-2.797-1.164-4.495-1.164-3.716 0-4.714 2.406-4.714 3.984 0 2.01 1.498 3.746 4.254 3.746.64 0 1.079-.06 1.66-.198v-1.597h-1.84v-2.7h5.394v6.467c-2.156.826-4.015 1.122-5.992 1.122-4.454 0-7.632-2.522-7.632-6.9 0-3.646 2.539-6.9 7.871-6.9 1.977 0 3.477.238 5.494.966zm9.395-.873v2.377h-4.602v1.565h4.387v2.223h-4.387v1.816h4.72v2.379h-8.128V9.697zm6.478 7.479c1.233 0 2.33-.85 2.33-2.3 0-1.256-.882-2.3-2.33-2.3-1.43 0-2.312 1.005-2.312 2.3 0 1.373.881 2.3 2.312 2.3m-.02-7.615c3.27 0 5.896 2.127 5.896 5.296 0 3.383-2.665 5.335-5.876 5.335-3.603 0-5.856-2.243-5.856-5.296 0-2.9 2.331-5.335 5.836-5.335"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogosGeoTraxHorizontal);
export default __webpack_public_path__ + "static/media/logos-geo-trax-horizontal.df2cc28ccb56d53375b3163dcd144263.svg";
export { ForwardRef as ReactComponent };